import { GlobalProvider } from './components/providers/global-provider'
export default GlobalProvider
